<template>
  <div class="option-item devices-container">
    <div class="header-title">
      <v-icon @click="isShowDetail=false" v-if="isShowDetail"
              class="vcs-icon-arrow-left primary2-800 mr-4 cursor-pointer"></v-icon>
      {{ isShowDetail ? $t('OPTIONS.DEVICE_INFO') : $t('OPTIONS.DEVICES_MANAGEMENT') }}
    </div>
    <div class="mx-4">
      <error-card v-if="error" :is-system-error="false" :error="error"></error-card>
    </div>
    <div class="w-full d-flex flex-column align-center mt-10" v-if="pageLoading">
      <vcs-loading size="56"></vcs-loading>
      <span class="sub-text">{{ $t('APPLICATIONS.LOADING') }}</span>
    </div>
    <div v-else-if="deviceLoginSessionList" class="content overflow-hidden">
      <!--List device-->
      <div class="d-flex flex-column flex-1 transform-animation" v-if="!isShowDetail">
        <div class="list-device">
          <template v-for="(item, index) in deviceLoginSessionList">
            <div :key="index" @click="openDetail(item)" class="item"
                 v-if="deviceDynamicInfo.data && deviceDynamicInfo.data.device_id === item.deviceId">
              <v-icon v-if="isDesktop(item.os)" class="vcs-icon-desktop mr-4"></v-icon>
              <v-icon v-else class="vcs-mobi-phone-icon mr-4"></v-icon>
              <div class="flex-1">
                <div class="device-name">{{ item.name }}</div>
                <span class="status text-cyan-600">{{ $t('OPTIONS.THIS_DEVICE') }}</span>
              </div>
              <v-icon class="vcs-icon-chevron-right"></v-icon>
            </div>
          </template>
          <div v-if="deviceLoginSessionList.length >= 2" class="ml-1 text-uppercase text-primary2-600 mt-4 mb-1">
            {{ $t('OPTIONS.OTHER_DEVICES') }}
          </div>
          <div class="list-other-devices">
            <template v-for="(item, index) in deviceLoginSessionList">
              <div class="item" @click="openDetail(item)" :key="index"
                   v-if="deviceDynamicInfo.data && deviceDynamicInfo.data.device_id !== item.deviceId">
                <v-icon v-if="isDesktop(item.os)" class="vcs-icon-desktop mr-4"></v-icon>
                <v-icon v-else class="vcs-mobi-phone-icon mr-4"></v-icon>
                <div class="flex-1">
                  <div class="device-name">{{ item.name }}</div>
                  <span class="status text-cyan-600" v-if="isOnline(item)">
                    <span :class="item.os === 'ios' ? 'text-uppercase' : 'text-capitalize'">{{
                        item.os | os
                      }}</span> - {{ $t('LAYOUT.ONLINE') }}
                  </span>
                  <span class="status" v-else>
                    <span :class="item.os === 'ios' ? 'text-uppercase' : 'text-capitalize'">{{
                        item.os | os
                      }}</span> - {{ item.lastLoginTime | recent }}
                  </span>
                </div>
                <v-icon class="vcs-icon-chevron-right"></v-icon>
              </div>
            </template>
          </div>
        </div>
        <div class="actions" v-if="deviceLoginSessionList && deviceLoginSessionList.length > 0">
          <vcs-btn
              @click="logoutAllDevices()"
              :ripple="false"
              :loading="logoutLoading"
              class="w-full primary2-200 mt-3"
          >
            <v-icon class="vcs-icon-logout-1 mr-2 primary2-950"></v-icon>
            {{ $t('OPTIONS.LOGOUT_ALL_DEVICES') }}
          </vcs-btn>
        </div>
      </div>

      <!--Device detail-->
      <div class="d-flex mt-4 flex-column flex-1 detail-animation" v-if="isShowDetail">
        <div class="device-detail">
          <div class="d-flex px-4 mb-4">
            <v-icon class="vcs-image-desktop-and-mobile mr-4"></v-icon>
            <div>
              <div class="text-primary2-950 font-18 font-weight-semi-bold">{{ selectedItem.name }}</div>
              <span class="text-primary2-600 text-capitalize font-12">{{ selectedItem.os | os }}</span>
            </div>
          </div>
          <div class="detail mt-4">
            <div>
              <span class="field">{{ $t('OPTIONS.REGISTRATION_DATE') }}</span>
              <span class="value">{{ selectedItem.registrationDate | date }}</span>
            </div>
            <div>
              <span class="field">{{ $t('OPTIONS.LAST_LOGIN') }}</span>
              <span class="value text-cyan-600" v-if="isOnline(selectedItem)">{{ $t('LAYOUT.ONLINE') }}</span>
              <span class="value" v-else>{{ selectedItem.lastLoginTime | recent }}</span>
            </div>
            <div>
              <span class="field">{{ $t('OPTIONS.SERVER') }}</span>
              <span class="value">{{ currentServerName }}</span>
            </div>
            <div>
              <span class="field">{{ $t('ACCOUNT.CLIENT_ID') }}</span>
              <span class="value">{{ selectedItem.clientId }}</span>
            </div>
            <div>
              <span class="field">{{ $t('DEVICE.DEVICE_ID') }}</span>
              <span class="value">{{ selectedItem.deviceId }}</span>
            </div>
            <!--            <div>-->
            <!--              <span class="field">{{$t('OPTIONS.NAME')}}</span>-->
            <!--              <span class="value">{{ deviceDynamicInfo.data.name }}</span>-->
            <!--            </div>-->
            <!--            <div>-->
            <!--              <span class="field">{{$t('OPTIONS.DEVICE')}}</span>-->
            <!--              <span class="value">N/A</span>-->
            <!--            </div>-->
            <!--            <div>-->
            <!--              <span class="field">{{$t('OPTIONS.OS')}}</span>-->
            <!--              <span class="value">{{ deviceDynamicInfo.data.os }}</span>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="actions">
          <vcs-btn
              class="mt-3 w-full red-200"
              @click="makeAction('deleteRegDevice')"
          >
            <v-icon class="vcs-icon-delete mr-2 red-700"></v-icon>
            <span class="text-red-700">{{ $t('OPTIONS.DELETE_CONNECTION') }}</span>
          </vcs-btn>
          <vcs-btn
              v-if="!isThisDeviceItSelf"
              @click="makeAction('logout')"
              :disabled="!isOnline(selectedItem)"
              :ripple="false"
              :loading="logoutLoading"
              class="mt-3 w-full primary2-150"
          >
            <v-icon class="vcs-icon-logout-1 mr-2 primary2-900"></v-icon>
            {{ $t('OPTIONS.LOGOUT') }}
          </vcs-btn>
        </div>
      </div>
    </div>
    <vcs-modal @ok="confirmOk()" v-model="confirmModal" :options="confirmOptions"
               :is-confirm-password="false">
      <template v-if="action === 'deleteRegDevice'">
        <div class="mb-4 text-primary2-800">
          {{ $t('OPTIONS.CANCEL_CONNECT_PERMISSION_DEVICE', {domainName: currentServerName}) }}
        </div>
      </template>
      <template v-else-if="action === 'logout'">
        <div class="text-primary2-800 font-weight-regular mb-2">{{ $t("OPTIONS.DO_YOU_WANT_TO_LOGOUT_THIS_DEVICE") }}
        </div>
        <div class="font-weight-semi-bold text-primary2-950">
          {{ selectedItem.name }}
        </div>
      </template>
    </vcs-modal>
  </div>
</template>

<script>

import Vue from "vue";
import msDataProvider from "@/services/msDataProvider";
import uiService from "@/services/uiService";
import {addAction} from "@/services/firebase/writeData";
import "@/helpers/filters/FormatDate";
import "@/helpers/filters/OS";
import * as moment from "moment";

export default Vue.extend({
  props: ["currentServerName", "enrollmentCredentials", "deviceDynamicInfo"],
  data() {
    return {
      selectedItem: {},
      isShowDetail: false,
      deviceLoginSessionRes: [],
      pageLoading: true,
      listDesktopOS: ['windows', 'linux', 'mac'],
      confirmOptions: {
        title: this.$t('OPTIONS.DELETE_CONNECTION'),
        cancel: this.$t('APP.CANCEL'),
        ok: this.$t('APP.DELETE_REG'),
        classOk: "red-100 text-red-600 rounded-lg"
      },
      confirmModal: false,
      action: 'deleteRegDevice',
      error: "",
      binding: {},
      logoutLoading: false
    }
  },
  computed: {
    deviceLoginSessionList() {
      return this.deviceLoginSessionRes.map(device => {
        return {
          loginSessionId: device.login_session_id,
          name: device.device_info.name,
          lastLoginTime: device.updated_time,
          registrationDate: device.enrollment_info.created_time,
          deviceId: device.device_info.device_id,
          os: device.device_info.type,
          clientId: device.enrollment_info.sdp_client_id,
          tokenInfo: device.token_info,
          status: device.status,
          enrollmentRequestId: device.enrollment_info.enrollment_request_id,
        }
      })
    },
    isThisDeviceItSelf() {
      if (this.deviceDynamicInfo && this.deviceDynamicInfo.data && this.deviceDynamicInfo.data.device_id) {
        return this.deviceDynamicInfo.data.device_id === this.selectedItem.deviceId;
      }
      return false;
    }
  },
  async mounted() {
    await this.getListDevices();
  },
  methods: {
    isDesktop(type) {
      return this.listDesktopOS.includes(type)
    },
    isOnline(item) {
      if (item.status === 'Active') {
        return moment(item.tokenInfo.exp * 1000).isAfter(moment(new Date().getTime()));
      }
      return false;
    },
    async confirmOk() {
      try {
        this.confirmModal = false;
        if (this.action === 'deleteRegDevice') {
          if (!this.isThisDeviceItSelf) {
            await this.logout();
          }
          await msDataProvider.executeCommand('deleteEnrollmentRequestByUser', this.selectedItem.deviceId);
          if (this.isThisDeviceItSelf) {
            await this.enrollmentDeleteCredentials();
            return;
          }
        }
        if (this.action === 'logout') {
          await this.logout();
          await this.sleep(1500);
        }
        await this.getListDevices();
      } catch (e) {
        console.log(e);
      } finally {
        this.logoutLoading = false;
        this.isShowDetail = false;
      }
    },
    openDetail(item) {
      this.selectedItem = item;
      this.isShowDetail = true;
    },
    async getListDevices() {
      try {
        this.pageLoading = true;
        this.deviceLoginSessionRes = await msDataProvider.executeCommand('deviceLoginSessionGetAllByUser');
      } catch (e) {
        console.log(e);
        this.error = e;
      } finally {
        this.pageLoading = false;
      }
    },
    async logoutAllDevices() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("LAYOUT.DO_YOU_REALLY_WANT_TO_LOGOUT_ALL_DEVICES"),
                title: this.$t("LAYOUT.CONFIRM_LOGOUT_ALL_DEVICE"),
                cancel: this.$t("LAYOUT.CANCEL"),
                ok: this.$t("LAYOUT.LOGOUT_ALL"),
                iconOk: 'icon-logout-white24'
              },
              true
          )
      ) {
        await uiService.executeCommand("try", {
          async func() {
            try {
              this.logoutLoading = true;
              await msDataProvider.executeCommand("authenLogout", {
                all_device: true,
                except_current_session: true
              });
              await this.sleep(1500);
              await this.getListDevices();
            } finally {
              this.logoutLoading = false;
            }
          },
          self: this,
        });
        sessionStorage.removeItem('userId')
      }
      await addAction('click_to_logout_all_device')
    },
    async logout(exceptCurrentSession = true) {
      await uiService.executeCommand("try", {
        async func() {
          this.logoutLoading = true
          await msDataProvider.executeCommand("authenLogout", {
            login_session_id: this.selectedItem.loginSessionId,
            all_device: false,
            except_current_session: exceptCurrentSession
          });
        },
        self: this,
      });
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async enrollmentDeleteCredentials() {
      await uiService.executeCommand("try", {
        async func() {
          await msDataProvider.executeCommand("enrollmentDeleteCredentials");
          await msDataProvider.executeCommand("authenLogout", {});
          await this.$router.push("/prepare").catch((e) => e);
        },
        self: this,
      });
    },
    async makeAction(action) {
      if (action === 'deleteRegDevice') {
        this.confirmOptions = {
          title: this.$t('OPTIONS.DELETE_CONNECTION'),
          cancel: this.$t('APP.CANCEL'),
          ok: this.$t('APP.DELETE'),
          iconOk: "vcs-icon-bin-1 red-600",
          classOk: "red-100 text-red-600 rounded-lg",
          closeable: false
        }
      }
      if (action === 'logout') {
        this.confirmOptions = {
          title: this.$t('APP.NOTIFICATION'),
          cancel: this.$t('APP.CANCEL'),
          ok: this.$t('LAYOUT.LOGOUT'),
          iconOk: 'icon-logout-white24',
          closeable: false
        }
      }
      this.action = action;
      this.confirmModal = true;
    },
  },

  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
})

</script>
